export default __webpack_public_path__ + "static/media/icon-close-white.dbbad54d.svg";